import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PublicFormIntakeService } from '../services/public-form-intake.service';

export const publicOrderFollowGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const intake = inject(PublicFormIntakeService);

  const raw = route.paramMap.get('followId')?.trim();
  if (!raw) {
    return router.createUrlTree(['/form-unavailable']);
  }

  try {
    await intake.verifyOrderFollow(raw);
    return true;
  } catch {
    return router.createUrlTree(['/form-unavailable']);
  }
};
